import { routeUrls } from '../../app/Routing/RouteUrls';
import { Stack, useMediaQuery, useTheme } from '@mui/material';
import { Breadcrumbs, IFlow, useEnvironment, workUtils, useWorkPageStore } from '@diana/core';
import { useBreadcrumbsRoot } from '../../hooks/useBreadcrumbsRoot';
import { WorkPageStatus } from './WorkPageStatus';
import { useMemo } from 'react';

export function WorkPageBreadcrumbs({
  displayName,
  workCode,
  workId,
  flow,
}: {
  displayName?: string;
  workCode?: string;
  workId?: string;
  flow?: IFlow | null;
}) {
  const { breakpoints } = useTheme();
  const environment = useEnvironment();
  const isLargeDevice = useMediaQuery(breakpoints.up('sm'));
  const showWorkStatusFeature = flow?.flowFeatures?.breadcrumbs?.showWorkStatusOnWorkPage ?? true;
  const needToShowWorkStatus = showWorkStatusFeature && isLargeDevice;
  const breadcrumbsRoot = useBreadcrumbsRoot('work');
  const data = useWorkPageStore((store) => store.data);

  const breadcrumbs = useMemo(() => {
    const title = workUtils.getFormattedWorkDisplayName({
      workCode,
      displayName,
      displayNameTemplate: flow?.displayNameTemplate,
      data,
    });

    return [
      breadcrumbsRoot,
      {
        title: `${flow?.displayName}`,
        link: routeUrls.workboard.url({ environment, flowId: flow?.id || '' }, null),
        hidden: !flow?.id,
      },
      { title, hidden: !workId },
    ];
  }, [
    breadcrumbsRoot,
    flow?.displayNameTemplate,
    flow?.id,
    flow?.displayName,
    displayName,
    environment,
    workCode,
    workId,
    data,
  ]);

  return needToShowWorkStatus ? (
    <Stack direction="row" alignItems="center">
      <Breadcrumbs items={breadcrumbs} />
      <WorkPageStatus />
    </Stack>
  ) : (
    <Breadcrumbs items={breadcrumbs} />
  );
}
